import { render, staticRenderFns } from "./HabilitationsItem.vue?vue&type=template&id=9e8af4b0&"
import script from "./HabilitationsItem.vue?vue&type=script&lang=js&"
export * from "./HabilitationsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports